import React from "react";
import { findAllProcedureGroupEvent } from "../../_events/procedure_group/find.event";
import { alertError } from "../../_utils/alerts";

export const useProcedureGroups = () => {

    const [data, setData] = React.useState([]);

    const loadData = () => {
        findAllProcedureGroupEvent()
        .then(json => {
            setData(json.list);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData();
    }, []);

    return { data, loadData };
}